 "use client";
 import React, { Suspense } from "react";   
import CustomerDashboardPage from "./LandingPage";
 export default function page() {
   return (
     <Suspense
       fallback={
         <div className="min-h-screen flex items-center justify-center">
           Loading...
         </div>
       }
     >
       <div>
         <CustomerDashboardPage />
       </div>
     </Suspense>
   );
 }